import api from '@/api/index.js'

const sold_season_tickets_report = {
  state: {
    loading: false,
    reportData: null,
    error: null
  },


  mutations: {
    SOLD_SEASON_TICKETS_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SOLD_SEASON_TICKETS_REPORT: (state, response) => {
      state.reportData = response;
      state.loading = false;
    },
    SOLD_SEASON_TICKETS_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetSoldSeasonTicketsReport({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }
      commit('SOLD_SEASON_TICKETS_REPORT_ERROR', null)
      commit('SOLD_SEASON_TICKETS_REPORT', null)
      commit('SOLD_SEASON_TICKETS_REPORT_LOADING', true)
      return api.get('reports/sold-season-tickets?' + reqQueryStr)
        .then((response) => {
          commit('SOLD_SEASON_TICKETS_REPORT', response)
        })
        .catch((error) => {
          commit('SOLD_SEASON_TICKETS_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SOLD_SEASON_TICKETS_REPORT_LOADING', false)
        })
    }
  },
}

export default sold_season_tickets_report
